import React from "react";
import backgroundLandingImg from "../../../../assets/background-landing.png";

const BlogNavHeader = () => {
  return (
    <section
      className="relative w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat py-20 sm:py-10 md:py-24 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 min-h-[200px] sm:min-h-[100px]"
      style={{ backgroundImage: `url(${backgroundLandingImg})` }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-[#6E3FC6]/65 pointer-events-none"></div>

      {/* ✅ Content Wrapper with extra top padding */}
      <div className="relative max-w-[720px] mx-auto pt-[30px]">
        <h1 className="font-semibold text-[26px] sm:text-[24px] md:text-[42px] lg:text-[48px] lowercase text-white leading-[50px] mb-1 leading-[32px] sm:leading-[40px] md:leading-[50px]">
          Frequently Ask Questions
        </h1>
      </div>
    </section>
  );
};

export default BlogNavHeader;
